export default __webpack_public_path__ + "static/media/hero.8a24706c.jpg";